import { render } from "./m_brief.vue?vue&type=template&id=25bbf427&scoped=true"
import script from "./m_brief.vue?vue&type=script&lang=js"
export * from "./m_brief.vue?vue&type=script&lang=js"

import "./m_brief.vue?vue&type=style&index=0&id=25bbf427&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bbf427"]])

export default __exports__